var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremiumQuanlityDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_89_14702)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2216 27.5378L33.9372 28.1067L31.0839 24.5511C30.9545 24.4023 30.7948 24.2829 30.6153 24.2011C30.4359 24.1193 30.241 24.077 30.0439 24.077C29.8467 24.077 29.6518 24.1193 29.4724 24.2011C29.293 24.2829 29.1332 24.4023 29.0039 24.5511L26.1505 28.1067L23.8216 27.5378C23.5984 27.4844 23.3653 27.4891 23.1444 27.5514C22.9236 27.6138 22.7224 27.7318 22.5601 27.894C22.3978 28.0563 22.2799 28.2575 22.2175 28.4783C22.1551 28.6992 22.1504 28.9324 22.2039 29.1556L23.7239 35.2089C23.7937 35.498 23.9589 35.7551 24.1927 35.939C24.4265 36.1228 24.7153 36.2226 25.0127 36.2222H34.9861C35.2835 36.2226 35.5724 36.1228 35.8062 35.939C36.04 35.7551 36.2051 35.498 36.275 35.2089L37.795 29.1556C37.8455 28.9368 37.8403 28.7088 37.78 28.4926C37.7196 28.2763 37.6059 28.0786 37.4494 27.9177C37.2929 27.7567 37.0984 27.6376 36.8839 27.5712C36.6694 27.5049 36.4417 27.4934 36.2216 27.5378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7771 26.889C22.3908 26.889 22.8882 26.3915 22.8882 25.7779C22.8882 25.1642 22.3908 24.6667 21.7771 24.6667C21.1635 24.6667 20.666 25.1642 20.666 25.7779C20.666 26.3915 21.1635 26.889 21.7771 26.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2215 26.889C38.8351 26.889 39.3326 26.3915 39.3326 25.7779C39.3326 25.1642 38.8351 24.6667 38.2215 24.6667C37.6078 24.6667 37.1104 25.1642 37.1104 25.7779C37.1104 26.3915 37.6078 26.889 38.2215 26.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 23.1111C30.6134 23.1111 31.1109 22.6137 31.1109 22C31.1109 21.3864 30.6134 20.8889 29.9998 20.8889C29.3861 20.8889 28.8887 21.3864 28.8887 22C28.8887 22.6137 29.3861 23.1111 29.9998 23.1111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3319 38.8889H24.6653C24.4295 38.8889 24.2034 38.7952 24.0367 38.6285C23.87 38.4618 23.7764 38.2357 23.7764 38C23.7764 37.7642 23.87 37.5381 24.0367 37.3714C24.2034 37.2047 24.4295 37.1111 24.6653 37.1111H35.3319C35.5677 37.1111 35.7938 37.2047 35.9605 37.3714C36.1272 37.5381 36.2208 37.7642 36.2208 38C36.2208 38.2357 36.1272 38.4618 35.9605 38.6285C35.7938 38.7952 35.5677 38.8889 35.3319 38.8889Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_89_14702",
    x: 0.666666,
    y: 0.666666,
    width: 58.6667,
    height: 58.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_89_14702"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_89_14702",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumQuanlityDefault);
export default __webpack_public_path__ + "static/media/premium-quanlity-default.5378cdc2f04d6ddeaf268a5048facaeb.svg";
export { ForwardRef as ReactComponent };